export const Days = [
  { name: "Monday", value: "Mon" },
  { name: "Tuesday", value: "Tue" },
  { name: "Wednesday", value: "Wed" },
  { name: "Thursday", value: "Thu" },
  { name: "Friday", value: "Fri" },
  { name: "Saturday", value: "Sat" },
  { name: "Sunday", value: "Sun" }
];



// WEBPACK FOOTER //
// ./src/core/utils/constants.js